import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import Divider from '../../../realize_overrides/components/divider/divider.jsx';
import { ProcessAPI, FormAPI } from 'lecom-api';
import { DividerEnums, DividerEnumsConvert } from '../../../realize_overrides/components/divider/divider_enums';
import GridContainer from '../../../grid/grid_container';
import Input from '../input/input_events_publisher.jsx';
import ScreenSizes from 'screen_sizes';
import InputGridFormFieldsModal from '../../../grid_form/components/modal/input_grid_form_fields_modal';
import { GridFormStore } from 'grid_form/reflux/grid_form_store';
import { FormEvents, FormEventHandler } from '../../events/form_event_handler';
import GridFormActionIds from 'grid_form/constants/grid_form_action_ids';

@mixin.decorate(window.CssClassMixin)
export class InputGroup extends React.Component {
	static propTypes = {
		inputs: PropTypes.object,
		contextType: PropTypes.string,
		data: PropTypes.object,
		errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		resource: PropTypes.string,
		isLoading: PropTypes.bool,
		disabled: PropTypes.bool,
		readOnly: PropTypes.bool,
		label: PropTypes.string,
		formStyle: PropTypes.string,
		wrapperClassName: PropTypes.string
	};

	static defaultProps = {
		inputs: {},
		contextType: '',
		data: {},
		errors: {},
		formStyle: 'default',
		label: null,
		isLoading: false,
		disabled: false,
		readOnly: false,
		themeClassKey: 'form.inputGroup',
		wrapperClassName: 'wrapper_input_group'
	};

	constructor(props) {
		super(props);

		const processAPI = ProcessAPI.currentProcess();
		this.isMobile = processAPI.isMobile();

		this.state = {
			expanded: true
		}
	}

	renderGrid(inputProps) {
		let inputComponents = [];
		let inputs = [];

		inputProps.fields['id'] = { component: 'hidden' };

		for (const gridInputId in inputProps.fields) {
			const gridInputProps = inputProps.fields[gridInputId];

			if (!gridInputProps.id) {
				gridInputProps.id = gridInputId;
			}

			const gridInputDisabled = gridInputProps.disabled || this.props.disabled;
			const gridInputReadOnly = gridInputProps.readOnly || this.props.readOnly;
			const gridInputIsLoading = gridInputProps.isLoading || this.props.isLoading;
			const inputsReadOnlyFalse = inputProps.fields.filter(input => input.component !== 'hidden' && !input.readOnly && input.visible !== false);
			const gridInputIsHide = (!inputsReadOnlyFalse.length && gridInputReadOnly) || !gridInputProps.visible ? 'hide' : '';

			if (gridInputProps.visible) {
				inputs.push(
					<Input
						formStyle={this.props.formStyle}
						{...gridInputProps}
						key={this.props.key || `input_${gridInputProps.id}`}
						disabled={gridInputDisabled}
						readOnly={gridInputReadOnly}
						isLoading={gridInputIsLoading}
						isMobile={this.isMobile}
						data={this.props.data}
						errors={this.props.errors}
						resource={this.props.resource}
						className={`${gridInputProps.className} ${gridInputIsHide}`}
						ref={"input_" + gridInputProps.id}
					/>
				);
			}

			if (gridInputProps.hasOwnProperty("lineBreak") && gridInputProps.lineBreak !== DividerEnums.NONE) {
				inputs.push(
					<Divider 
						type={DividerEnumsConvert[gridInputProps.lineBreak]} 
						key={"divider_" + gridInputProps.id}
						isVisible={gridInputProps.readOnly || gridInputProps.visible}
						readOnly={!gridInputProps.visible ? true : gridInputReadOnly}
					/>
				);
			}
		}

		if (this.isMobile && window.innerWidth <= ScreenSizes.SMALL_SCREEN_WIDTH) {
			const modalProps = Object.assign({}, inputProps);
			modalProps.inputs = inputs;
			modalProps.isMobile = this.isMobile;
			inputComponents.push(
				<InputGridFormFieldsModal
					{...modalProps}
					ref="inputsModal"
				/>
			);
		} else {
			inputComponents = inputComponents.concat(inputs);
		}

		const formAPI = FormAPI.form(inputProps.formId);
		const gridDisabled = formAPI.fields(inputProps.id).disabled() || false;
		const notReadOnly = inputs.filter(input => input.props.component !== 'hidden' && input.props.visible !== false && !input.props.readOnly);
		const gridVisible = formAPI.fields(inputProps.id).visible() || false;
		const gridColumns = formAPI.fields(inputProps.id).columns() || inputProps.columns;

		inputComponents.push(
			<GridContainer
				{...inputProps}
				columns={gridColumns}
				readOnly={!notReadOnly.length && gridVisible ? true : false}
				disabled={gridDisabled}
				createButton={inputProps.actions.find(a => a.id === GridFormActionIds.CREATE)}
				updateButton={inputProps.actions.find(a => a.id === GridFormActionIds.UPDATE)}
				cancelButton={inputProps.actions.find(a => a.id === GridFormActionIds.CANCEL)}
				actions={inputProps.actions}
				ref='gridContainer'
				key='GRID_CONTAINER'
				isMobile={this.isMobile}
			/>
		);

		return inputComponents;
	}

	handleCollapseGroup(groupKey, e) {
		const expansible = $(`#group-name_${groupKey}`).hasClass('expansible');

		if (expansible) {
			const nodeGroupName = $(ReactDOM.findDOMNode(this.refs[`group_${groupKey}`]));
			const nodeGroupArrow = nodeGroupName.find(".material-icons");
			const nodeGroupFields = nodeGroupName.next(".group-fields");
			nodeGroupFields.toggle();
			nodeGroupArrow.html(nodeGroupArrow.html().trim() === "keyboard_arrow_up" ? "keyboard_arrow_down" : "keyboard_arrow_up");
			this.setState({...this.state, expanded: nodeGroupArrow.html().trim() === "keyboard_arrow_up" ? true : false});
			const formAPI = FormAPI.form(this.props.formId);
			formAPI.publish(FormEvents.CLICK);
		}
	}

	handleOnkeyDown(groupKey, e){
		if(e.keyCode === 13) {
			e.stopPropagation();
			e.preventDefault();
			this.handleCollapseGroup(groupKey, e);
		}
	}

	renderFieldsGroups() {
		const inputsProps = this.props.inputs;
		const formApi = ProcessAPI.currentProcess().form();
		let fieldsGroupings = formApi.fieldsGroupings();

		let inputsGroups = [];
		let inputComponents = {};

		fieldsGroupings = fieldsGroupings.reduce((acc, cur) => {
			const accFilter = acc.map(f => {
				const arrIds = cur.fields.map(cf => cf.gridFormParent);

				return {
					...f,
					fields: f.fields.filter(f2 => {
						return !arrIds.includes(f2.id);
					})
				};
			});

			return [...accFilter, cur]
		}, []);

		fieldsGroupings.forEach(group => {
			const currentGroupFields = group.fields;
			const isVisible =  (window[group.identifier] && typeof window[group.identifier] === 'object') ? window[group.identifier].isVisible : true;
			inputComponents = {};

			currentGroupFields.forEach(field => {
				if (inputsProps.hasOwnProperty(field.id)) {
					inputComponents[field.id] = inputsProps[field.id];
				}

				if (field.gridFormParent && inputsProps.hasOwnProperty(field.gridFormParent)) {
					inputComponents[field.gridFormParent] = inputsProps[field.gridFormParent];
				}

			});

			if (Object.keys(inputComponents).length) {
				if (group.name === '') {
					inputsGroups.push(this.renderInputs(inputComponents));
				}
				else {
					const  classIsVisible = isVisible === false ? 'hide' : '';

					inputsGroups.push(
						<div className={`groups group-${group.id}`} key={`group-${group.id}`} id={group.identifier}>
							<div id={`group-border_${group.id}`} className={`group-border ${classIsVisible}`}></div>
							<div id="group_info" className="hidden">{Realize.i18n.t('general.group_label').replace('@', Realize.i18n.t(this.state.expanded ? 'general.open' : 'general.close')) }</div>
							{!group.expansible ? (
								<div ref={`group_${group.id}`} id={`group-name_${group.id}`} className={`group-name ${classIsVisible}`} onClick={
									$(`#group-name_${group.id}`).hasClass('expansible') === true ? this.handleCollapseGroup.bind(this, group.id) : ''
								}>
									<span>{group.name}</span>
									<i id={`group_${group.id}`} className="material-icons right not-expansible">keyboard_arrow_up</i>
								</div>
							) : (
								<div ref={`group_${group.id}`} id={`group-name_${group.id}`}
									className={`group-name expansible ${classIsVisible}`}
									onClick={
										$(`#group-name_${group.id}`).hasClass('expansible') === true ? this.handleCollapseGroup.bind(this, group.id) : ''
									}
									onKeyDown={this.handleOnkeyDown.bind(this, group.id)}
									tabIndex="0"
									aria-expandable={this.state.expanded}
									aria-label={group.name}
									aria-describedby={"group_info"}>
									<span>{group.name}</span>
									<div tabIndex="0"
									onKeyDown={this.handleOnkeyDown.bind(this, group.id)}
									aria-expandable={this.state.expanded}
									aria-label={Realize.i18n.t('general.group_label').replace('@', Realize.i18n.t(this.state.expanded ? 'general.open' : 'general.close')) }
									style={{position: 'absolute', top: '0', height: '25px', width: '25px', right: '11px'}}>
										<i id={`group_${group.id}`} className="material-icons right group-expansible" tabIndex="-1">keyboard_arrow_up</i>
									</div>
								</div>
							)}
							<div id={`group-fields_${group.id}`} className={`group-fields ${classIsVisible}`}>{this.renderInputs(inputComponents)}</div>
						</div>
					);
				}
			}
		});

		return inputsGroups;
	}

	renderErrorsGrid(errorGrid) {
		if (typeof errorGrid === 'string')
			return errorGrid;

		if (typeof errorGrid === 'object')
			return errorGrid.join("/");
	}

	renderInputs(objInputs) {
		const inputsProps = objInputs || this.props.inputs;
		let inputComponents = [];

		for (const inputId in inputsProps) {
			if (inputsProps.hasOwnProperty(inputId)) {
				let inputProps = inputsProps[inputId];
				let hide = !inputProps.visible ? 'hide' : '';

				if (inputProps.type === 'GRID'){
					let errorGrid = FormAPI.form(inputProps.formId).fields(inputProps.id).errors();
					let classErrorGrid = FormAPI.form(inputProps.formId).fields(inputProps.id).errors() ? 'invalid' : '';

					inputComponents.push(
						<div className={`container-input-grid ${hide} ${classErrorGrid}`}>
							<div className={`col m12 input-grid`} id={`input__${inputId}`}>
								{this.renderGrid(inputProps)}
							</div>
							{errorGrid &&
								<span className="errorGrid">{this.renderErrorsGrid(errorGrid)}</span>
							}
						</div>
					);
				} else {
					if (!inputProps.id) {
						inputProps.id = inputId;
					}

					const inputReadOnly = inputProps.readOnly ? true : this.props.readOnly;
					const inputDisabled = inputProps.disabled ? true : this.props.disabled;
					const inputIsLoading = inputProps.isLoading ? true : this.props.isLoading;

					inputComponents.push(
						<Input
							formStyle={this.props.formStyle}
							inputWrapperComponent={this.props.inputWrapperComponent}
							key={this.props.key || `input_${inputId}`}
							{...inputProps}
							className = {`${inputProps.className} ${hide}`}
							disabled={inputDisabled}
							readOnly={inputReadOnly}
							isLoading={inputIsLoading}
							isMobile={this.isMobile}
							data={this.props.data}
							errors={this.props.errors}
							resource={this.props.resource}
							ref={`input_${inputId}`}
						/>
					);

					if (inputProps.hasOwnProperty("lineBreak") && inputProps.lineBreak !== DividerEnums.NONE) {
						inputComponents.push(
							<Divider
								type={DividerEnumsConvert[inputProps.lineBreak]}
								key={`divider_${inputId}`}
								isVisible={inputProps.readOnly ? true : inputProps.visible}
								readOnly={!inputProps.visible ? true : inputProps.readOnly}
							/>
						);
					}
				}
			}
		}

		return inputComponents;
	}

	serialize() {
		var inputRefs = { };
		var inputKeyRefs = Object.keys(this.refs);
		for (let cont = 0, len = inputKeyRefs.length; cont < len; cont++) {
			let refName = inputKeyRefs[cont];
			if (refName.match(/^input_/) && !this.refs[refName].props.hidden) {
				Object.assign(inputRefs, this.refs[refName].serialize());
			}
		}

		return inputRefs;
	}

	renderLabel() {
		return this.props.label === null 
		? ''
		: <h5 tabIndex="0">{this.props.label}</h5>;
	}

	render() {
		return (
			<div className={this.props.wrapperClassName}>
				<div className={Realize.themes.getCssClass('form.inputGroup')}>
					{this.renderLabel()}
					{this.props.contextType === 'FORM' ? this.renderFieldsGroups() : this.renderInputs()}
				</div>
			</div>
		);
	}
}


export default InputGroup;
